import { createSvgIcon } from "@mui/material";

import { palette } from "~frontend/theme";

export default createSvgIcon(
  <svg viewBox="0 0 24 24" data-testid="CheckBoxOutlineBlankIcon">
    <rect
      width="18"
      height="18"
      x="3"
      y="3"
      fill="white"
      stroke={palette.midGray}
    />
  </svg>,
  "CheckBoxUnchecked"
);
